import { Component, Inject } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { BaseComponent } from '../../shared/base-components/base.component';
import { ControlValidationMessagesService } from '../../shared/validators/control-validation-messages.service';
import { CustomerManageService } from '../shared/customer-manage.service';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA} from '@angular/material/legacy-dialog';
import { finalize } from 'rxjs/operators';

export class MVDNowChangeEmailContext {

    constructor(public customerNumberId: number) { }
}

@Component({
    templateUrl: './mvdnow-change-email-modal.html'
})

export class MVDNowChangeEmailModalComponent extends BaseComponent {
    public form: UntypedFormGroup;
    public showSearchButtonLoading = false;
    public customerNumberId: number;
    public inProgress: boolean;

    constructor(
        public fb: UntypedFormBuilder,
        private customerService: CustomerManageService,
        public dialogRef: MatDialogRef<MVDNowChangeEmailModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: MVDNowChangeEmailContext) {
        super();

        this.customerNumberId = this.data.customerNumberId;
    }

    ngOnInit() {
        this.form = this.fb.group({
            'email': [null, Validators.compose([Validators.required, ControlValidationMessagesService.optionalEmailValidator])]
        });
    }

    public cancel() {
        this.dialogRef.close();
    }

    public reset() {
        this.showValidationComponent = false;
        this.form.reset();
    }

    public searchEmail() {
        this.showValidationComponent = false;
        if (this.form.valid) {
            this.inProgress = true;
            let email = this.form.get('email').value;
            this.customerService.changeEmail(this.customerNumberId, email)
                .pipe(finalize(() => this.inProgress = false))
                .subscribe(
                    (data) => {
                        this.dialogRef.close(email);
                    },
                    (error) => {
                        this.handleValidationResult(error);
                    }
                );
        }
    }
}
